import { useUserSetting } from "@/api/services/main/user-setting";
import { IconEditor, IconRefresh } from "@/assets/icons";
import { ButtonNew } from "@/modules/irohana-components/elements/ButtonNew";
import { FooterContainer } from "@/components/commons/FooterContainer";
import { LoadingArea } from "@/modules/irohana-components/elements/Loading/Loading";
import { TopPage } from "@/modules/irohana-components/elements/TopPageNew";
import { NotificationSettingSection } from "@/features/user-settings/components/NotificationSettingSection";
import { ProfileSection } from "@/features/user-settings/components/ProfileSection";
import { SealSection } from "@/features/user-settings/components/SealSection";
import { SettingCard } from "@/features/user-settings/components/SettingCard";
import { UserSettingContainer } from "@/features/user-settings/components/UserSettingContainer";
import { UserSettingLayout } from "@/features/user-settings/components/UserSettingLayout";
import {
  NOTIFICATION_SETTING_DESCRIPTION,
  PROFILE_SETTING_DESCRIPTION,
  USER_SETTING_SECTION_ID,
  USER_SETTING_SECTION_TITLE,
} from "@/features/user-settings/constants/sections";
import { CENTER_ROUTES, openCenterPage } from "@/utils/center";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

const UserSettingDetail: FC = () => {
  const navigate = useNavigate();
  const { data, isLoading, isRefetching, refetch } = useUserSetting();

  const detail = data?.data;

  const openCenterUserSetting = () => openCenterPage(CENTER_ROUTES.userSettingDetail);

  if (isLoading) {
    return <LoadingArea height={400} />;
  }

  return (
    <UserSettingContainer>
      <TopPage title="ユーザー設定" enablePageBack={false} />

      <UserSettingLayout
        sections={[
          {
            id: USER_SETTING_SECTION_ID.profile,
            title: USER_SETTING_SECTION_TITLE.profile,
            content: (
              <SettingCard
                title={USER_SETTING_SECTION_TITLE.profile}
                rightContent={
                  <ButtonNew variant="secondary" size="sm" isLoading={isRefetching} startIcon={<IconRefresh />} onClick={() => refetch()}>
                    再読み込み
                  </ButtonNew>
                }
              >
                <Stack gap={3}>
                  <Typography variant="cap12" color={text.secondary}>
                    {PROFILE_SETTING_DESCRIPTION}
                  </Typography>
                  <ProfileSection detail={detail} readOnly onChangeEmail={openCenterUserSetting} onChangePassword={openCenterUserSetting} />
                </Stack>
              </SettingCard>
            ),
          },
          {
            id: USER_SETTING_SECTION_ID.notification,
            title: USER_SETTING_SECTION_TITLE.notification,
            content: (
              <SettingCard title={USER_SETTING_SECTION_TITLE.notification}>
                <Stack gap={2}>
                  <Typography variant="cap12" color={text.secondary}>
                    {NOTIFICATION_SETTING_DESCRIPTION}
                  </Typography>
                  <NotificationSettingSection value={detail?.emailDeliveryOptions ?? []} readOnly />
                </Stack>
              </SettingCard>
            ),
          },
          {
            id: USER_SETTING_SECTION_ID.seal,
            title: USER_SETTING_SECTION_TITLE.seal,
            content: (
              <SettingCard title={USER_SETTING_SECTION_TITLE.seal}>
                <SealSection detail={detail} readOnly />
              </SettingCard>
            ),
          },
        ]}
        footer={
          <FooterContainer>
            <Stack direction="row" justifyContent="flex-end">
              <ButtonNew variant="secondary" startIcon={<IconEditor />} onClick={() => navigate(AppRoutes.userSettingEdit)}>
                編集
              </ButtonNew>
            </Stack>
          </FooterContainer>
        }
      />
    </UserSettingContainer>
  );
};

export default UserSettingDetail;
